// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__fXPEO","content":"RecentSearches_content__qzSkv"};